import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import "./PricelistContent.css";
import MainContent from "../MainContent";

export interface SidebarProps {}

interface StateProps {}

interface DispatchProps {}

export interface PricelistContentOwnProps {
  isSidebarOpen: boolean;
  onRequestCloseSidebar: () => void;
  isDraftMode?: boolean;
}

type InternalProps = PricelistContentOwnProps & StateProps & DispatchProps;

const PricelistContentView = (props: InternalProps) => (
  <>{PricelistContent(props)}</>
);

function PricelistContent(props: InternalProps) {
  const handleToggle = (event: React.MouseEvent) => {

    if (!props.isSidebarOpen) return;

    const target = event.target as HTMLElement;
    if (
      target.tagName === "INPUT" ||
      target.tagName === "BUTTON" ||
      target.tagName === "A" ||
      target.tagName === "LABEL" ||
      target.closest("input") ||
      target.closest("button") ||
      target.closest("a") ||
      target.closest("label") ||
      target.closest(".ant-checkbox") ||
      target.closest(".ant-checkbox-wrapper") ||
      target.closest(".ant-checkbox-group") ||
      target.closest(".ant-select") ||
      target.closest(".ant-select-selector") ||
      target.closest(".ant-dropdown") ||
      target.closest(".ant-picker") ||
      target.closest('[role="button"]') ||
      target.closest('[role="checkbox"]') ||
      target.closest("td")?.querySelector(".ant-checkbox-group")
    ) {
      return;
    }

    props.onRequestCloseSidebar();
  };

  return (
    <div className="pricelist" onClick={handleToggle}>
      <div className="content">
        <MainContent isDraftMode={props.isDraftMode} />
      </div>
    </div>
  );
}

const mapStateToProps = (state: any, ownProps: SidebarProps): StateProps => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {};
};

export default connect<StateProps, DispatchProps, PricelistContentOwnProps, any>(
  mapStateToProps,
  mapDispatchToProps
)(PricelistContentView);
